const kickoffFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Oslo",
  weekday: "short",
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatKickoff(iso: string): string {
  const parsed = Date.parse(iso);
  return Number.isNaN(parsed) ? iso : kickoffFormatter.format(parsed);
}

export function formatPercent(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

/** Signed percent: "+3.2%" / "−1.4%". Uses a real minus sign for visual symmetry. */
export function formatSignedPercent(value: number): string {
  const pct = (value * 100).toFixed(1);
  if (value > 0) return `+${pct}%`;
  if (value < 0) return `−${pct.replace("-", "")}%`;
  return `${pct}%`;
}

/** Format a Kelly stake fraction as a percentage of bankroll. */
export function formatStake(fraction: number): string {
  if (fraction <= 0) return "—";
  if (fraction < 0.005) return `<0.5%`;
  return `${(fraction * 100).toFixed(1)}%`;
}

const dayLabelFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Oslo",
  weekday: "short",
  day: "2-digit",
  month: "short",
});

/**
 * Section heading for a day bucket: "Today" / "Tomorrow" / "Wed 22 May".
 * `daysAhead` is the integer offset from today (0..6); `isoDate` is `YYYY-MM-DD`
 * in Oslo TZ — used to render the long form when it isn't today/tomorrow.
 */
export function formatDayLabel(daysAhead: number, isoDate: string): string {
  if (daysAhead === 0) return "Today";
  if (daysAhead === 1) return "Tomorrow";
  const parsed = Date.parse(`${isoDate}T12:00:00Z`);
  if (Number.isNaN(parsed)) return isoDate;
  return dayLabelFormatter.format(parsed);
}
